import { formatDate, formatTime, formatCurrency } from '@smarttransit/common'
import { updateQueryParams } from '@smarttransit/common-client'

import {
  findEvents,
  findTotalEvents,
  getArchivedEvents,
  findTotalArchivedEvents,
  getEventCapacityStatus,
  // getEventTransportationProfiles,
  archiveEvent,
  unarchiveEvent
} from '@/services/transportation-profile-events-service'

import {
  isAuthorized,
  initBreadcrumbs,
  addAlert,
  isOnlyInvestor as isOnlyInvestorFn
} from '../../../../utilities/helpers'

export default {
  props: {
    signedInUser: Object,
    forceRootViewRefresh: Function
  },
  data () {
    return {
      events: [],
      archivedEvents: [],
      breadcrumbs: [],
      totalEvents: 0,
      totalArchivedEvents: 0,
      apiInProgress: false,
      pagination: { sortBy: 'eventDate', descending: true },
      searchKeywords: '',
      headers: [],
      archivedHeaders: [],
      dateFrom: null,
      dateTo: null,
      metricsByEventId: {},
      componentMounted: false,
      selectedTab: 'events'
    }
  },
  watch: {
    $route () {
      this.breadcrumbs = initBreadcrumbs.call(this)

      if (this.$router.currentRoute.name === 'routes-events') {
        this.loadFromQueryParams()
        this.searchEvents(1)
      }
    }
    // dateFrom (val) {
    //   this.updateQueryParams({ dateFrom: val })
    // },
    // dateTo (val) {
    //   this.updateQueryParams({ dateTo: val })
    // },
    // pagination (updatedPagination) {
    //   this.updateQueryParams({ ...updatedPagination })
    // }
  },
  computed: {
    isOnlyInvestor () {
      return isOnlyInvestorFn(this.$props.signedInUser)
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.breadcrumbs = initBreadcrumbs.call(this)
    })

    if (this.$router.currentRoute.name === 'routes-events') {
      initTableHeaders.call(this)
      initArchivedTableHeaders.call(this)
      this.searchEvents(1)
    }

    this.componentMounted = true
  },
  methods: {
    loadFromQueryParams () {
      if (this.$route.query.descending) {
        this.pagination.descending = this.$route.query.descending
      }

      if (this.$route.query.page) {
        this.pagination.page = this.$route.query.page
      }

      if (this.$route.query.rowsPerPage) {
        this.pagination.rowsPerPage = this.$route.query.rowsPerPage
      }

      if (this.$route.query.sortBy) {
        this.pagination.sortBy = this.$route.query.sortBy
      }

      if (this.$route.query.searchKeywords) {
        this.searchKeywords = this.$route.query.searchKeywords
      }

      if (this.$route.query.dateFrom) {
        this.dateFrom = this.$route.query.dateFrom
      }

      if (this.$route.query.dateTo) {
        this.dateTo = this.$route.query.dateTo
      }
    },
    updateQueryParams (providedData) {
      const paramsObj = {
        searchKeywords: this.searchKeywords && this.searchKeywords.split(' ').map((o) => o.trim()),
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        page: this.pagination.page,
        rowsPerPage: this.pagination.rowsPerPage,
        descending: this.pagination.descending,
        sortBy: this.pagination.sortBy,
        ...providedData
      }

      this.lastParams = updateQueryParams({ paramsObj, route: this.$route, lastParams: this.lastParams })
    },
    hasUserType (role) {
      const { signedInUser } = this.$props
      return (signedInUser && isAuthorized(signedInUser, role))
    },
    onPagination () {
      if (this.componentMounted) {
        this.searchEvents()
      }
    },
    onTabChanged () {
      if (this.componentMounted) {
        this.searchEvents(1)
      }
    },
    /**
     * @param {number} setPage - force the page to be this over whatever pagination has
     * @returns {Promise<void>}
     */
    async searchEvents (setPage) {
      try {
        let order
        let promises = []
        this.apiInProgress = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const offset = ((setPage || page) - 1) * (rowsPerPage || 0)
        const limit = rowsPerPage

        if (sortBy) {
          order = `${sortBy} ${descending ? 'DESC' : 'ASC'}`
        }

        const trimmedKeywords = String(this.searchKeywords).trim()

        if (this.selectedTab === 'events') {
          promises.push(findEvents({
            keywords: trimmedKeywords,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            limit,
            offset,
            order
          }))

          promises.push(findTotalEvents({
            keywords: trimmedKeywords,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo
          }))

          const [results, totalCount] = await Promise.all(promises)

          this.totalEvents = totalCount

          this.events = results.map((o) => {
            return this.setEvent(o)
          })
        } else if (this.selectedTab === 'archived-events') {
          promises.push(getArchivedEvents({
            keywords: trimmedKeywords,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            limit,
            offset,
            order
          }))

          promises.push(findTotalArchivedEvents({
            keywords: trimmedKeywords,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo
          }))

          const [results, totalCount] = await Promise.all(promises)

          this.totalArchivedEvents = totalCount

          this.archivedEvents = results.map((o) => {
            return this.setArchivedEvent(o)
          })
        }
      } finally {
        this.apiInProgress = false
      }
    },
    setEvent ({ id, name, eventDate, flatRateFee, returnFlatRateFee, dateCreated, dateUpdated, metadata }) {
      const newObj = Object.assign({}, {
        id,
        name,
        eventDate,
        flatRateFee,
        returnFlatRateFee,
        dateCreated,
        dateUpdated,
        metadata
      })

      newObj.eventDateLabel = newObj.eventDate ? formatDate(newObj.eventDate) : ''
      newObj.dateCreatedLabel = newObj.dateCreated ? `${formatTime(newObj.dateCreated)}, ${formatDate(newObj.dateCreated)}` : ''
      newObj.dateUpdatedLabel = newObj.dateUpdated ? `${formatTime(newObj.dateUpdated)}, ${formatDate(newObj.dateUpdated)}` : ''
      newObj.flatRateFeeLabel = newObj.flatRateFee ? formatCurrency(newObj.flatRateFee) : ''
      newObj.returnFlatRateFeeLabel = newObj.returnFlatRateFee ? formatCurrency(newObj.returnFlatRateFee) : ''
      newObj.isArchiveInProgress = false

      return newObj
    },
    setArchivedEvent ({ id, name, eventDate, flatRateFee, returnFlatRateFee, dateCreated, dateArchived, metadata }) {
      const newObj = {
        id,
        name,
        eventDate,
        flatRateFee,
        returnFlatRateFee,
        dateCreated,
        dateArchived,
        metadata
      }

      newObj.eventDateLabel = newObj.eventDate ? formatDate(newObj.eventDate) : ''
      newObj.dateCreatedLabel = newObj.dateCreated ? `${formatTime(newObj.dateCreated)}, ${formatDate(newObj.dateCreated)}` : ''
      newObj.dateArchivedLabel = newObj.dateArchived ? `${formatTime(newObj.dateArchived)}, ${formatDate(newObj.dateArchived)}` : ''
      newObj.flatRateFeeLabel = newObj.flatRateFee ? formatCurrency(newObj.flatRateFee) : ''
      newObj.returnFlatRateFeeLabel = newObj.returnFlatRateFee ? formatCurrency(newObj.returnFlatRateFee) : ''
      newObj.isArchiveInProgress = false

      return newObj
    },
    loadEvent (eventId) {
      this.$router.push({ name: 'routes-events-event', params: { eventId: eventId || '' } })
    },
    async archiveEventRow (event) {
      if (!this.hasUserType('admin') || !event || !event.id) {
        return
      }

      if (!confirm('Confirm archiving this event?')) {
        return
      }

      event.isArchiveInProgress = true
      try {
        await archiveEvent({ id: event.id })
        addAlert({ message: 'Event archived', type: 'success' })
        await this.searchEvents(1)
      } catch (err) {
        addAlert({ message: err, type: 'error' })
      } finally {
        event.isArchiveInProgress = false
      }
    },
    async unarchiveEventRow (event) {
      if (!this.hasUserType('admin') || !event || !event.id) {
        return
      }

      if (!confirm('Confirm un-archiving this event?')) {
        return
      }

      event.isArchiveInProgress = true
      try {
        await unarchiveEvent({ id: event.id })
        addAlert({ message: 'Event un-archived', type: 'success' })
        await this.searchEvents(1)
      } catch (err) {
        addAlert({ message: err, type: 'error' })
      } finally {
        event.isArchiveInProgress = false
      }
    },
    async loadMetricsForEvent (eventId) {
      const current = this.metricsByEventId[eventId] || {}

      this.$set(this.metricsByEventId, eventId, Object.assign({}, current, {
        loading: true,
        error: null
      }))

      try {
        const [metrics, transportationProfileData] = await Promise.all([
          getEventCapacityStatus({ id: eventId }),
          Promise.resolve({ profiles: [] })
          // getEventTransportationProfiles({ id: eventId })
        ])

        this.$set(this.metricsByEventId, eventId, {
          ...{ capacityStatus: metrics },
          ...{ transportationProfiles: transportationProfileData.profiles },
          ...{
            loading: false,
            error: null
          }
        })
      } catch (err) {
        console.error('Error loading event metrics', err)
        this.$set(this.metricsByEventId, eventId, {
          ...current,
          ...{
            loading: false,
            error: err
          }
        })
      }
    }
  }
}

function initTableHeaders () {
  this.headers = [
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    {
      text: 'Event Date',
      align: 'left',
      sortable: true,
      value: 'eventDate'
    },
    {
      text: 'Flat Rate Fee',
      align: 'left',
      sortable: false,
      value: 'flatRateFee'
    },
    {
      text: 'Return Flat Rate Fee',
      align: 'left',
      sortable: false,
      value: 'returnFlatRateFee'
    },
    {
      text: 'Capacity (outbound / return)',
      align: 'left',
      sortable: false,
      value: 'capacity'
    },
    {
      text: 'Profiles',
      align: 'left',
      sortable: false,
      value: 'profiles'
    },
    {
      text: 'Date Updated',
      align: 'left',
      sortable: true,
      value: 'dateUpdated'
    },
    { text: 'Actions', sortable: false }
  ]
}

function initArchivedTableHeaders () {
  this.archivedHeaders = [
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    {
      text: 'Event Date',
      align: 'left',
      sortable: true,
      value: 'eventDate'
    },
    {
      text: 'Flat Rate Fee',
      align: 'left',
      sortable: false,
      value: 'flatRateFee'
    },
    {
      text: 'Return Flat Rate Fee',
      align: 'left',
      sortable: false,
      value: 'returnFlatRateFee'
    },
    {
      text: 'Date Created',
      align: 'left',
      sortable: true,
      value: 'dateCreated'
    },
    {
      text: 'Date Archived',
      align: 'left',
      sortable: true,
      value: 'dateArchived'
    },
    { text: 'Actions', sortable: false }
  ]
}
